import { lazy } from "react"
import type { FormMarkdownEditor as FormMarkdownEditorCmp } from "./FormMarkdownEditor"

export const FormMarkdownEditor = lazy(() =>
  import("./FormMarkdownEditor").then((module) => ({
    default: module.FormMarkdownEditor,
  })),
) as typeof FormMarkdownEditorCmp
